import { animate } from '../../vendor/anime.esm.js';
import { DURATION, EASE, resolveDuration } from '../motion-tokens.js';

/**
 * Coreografía de entrada de los bloques de tienda (`ofertas`, `novedades`, `top`, `habitual`).
 *
 * Registrada SIN variante (gotcha #18): sin entrada en variant-animations.js caerían al fallback
 * genérico, el que puede congelar un tween y dejar texto semi-invisible en el publicado.
 *
 * Solo se anima el TÍTULO (y el aviso para entrar). Las tarjetas NO: las pinta el runtime
 * (core/tienda-runtime.js) cuando llegan los datos —antes o después de esta entrada—, y animarlas
 * aquí competiría con ese repintado escribiendo los mismos targets. Entran con su propio fundido
 * de CSS (`.ts-section[data-ts-estado="items"] .ts-card`).
 */
export const tiendaAnim = (el) => {
    const titulo = el.querySelector('[data-field="title"]');
    const aviso = el.querySelector('.ts-gate');
    const piezas = [titulo, aviso].filter(Boolean);
    if (!piezas.length) return null;
    piezas.forEach((p) => { p.style.opacity = '0'; p.style.transform = 'translateY(18px)'; });
    return animate(piezas, {
        opacity: [0, 1],
        translateY: [18, 0],
        duration: resolveDuration(DURATION.normal),
        ease: EASE.refined,
    });
};
